import Axios from 'axios';
import qs from 'qs';
import ls from '../utils/localStorage.js';

// 配置Axios默认表头带Token
let token = ls.getItem('access_token');
if (token) {
    Axios.defaults.headers.common['authorization'] = token.access_token;
}

//  配置Axios 创建Axios实例请求数据
let instance = Axios.create({
    baseURL: "https://ymapi.jzymc.com/api",
   // baseURL: "http://localhost/api",
   // timeout: 1000,
    withCredentials:false,
    headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
})

/***********************文章管理区*********************************/

// 文章类别
export const getCategories = () => {
    return instance.get('/categories').then(response => response.data);
};

// 文章数据列表
export const getArticle = (cateagory,city) => {
    return instance.get('/articles?category_id='+cateagory+'&city='+city).then(response => response.data);
};

// 文章数据详情
export const getArticleDetail = (id) => {
    return instance.get('/articles/'+id).then(response => response.data);
};


/***********************门店管理区*********************************/

// 门店数据列表
export const getShop = (lnglat,city) => {
    return instance.get('/shops?lnglat='+lnglat+'&city='+city).then(response => response.data);
};

// 门店数据详情
export const getShopDetail = (id,lnglat) => {
    return instance.get('/shops/'+id+'?lnglat='+lnglat).then(response => response.data);
};


/***********************专家管理区*********************************/

// 专家数据列表
export const getExpert = (city) => {
    return instance.get('/experts?city='+city).then(response => response.data);
};


/***********************案例管理区*********************************/

// 案例数据列表
export const getCases = (city) => {
    return instance.get('/cases?city='+city).then(response => response.data);
};

// 案例数据详情
export const getCasesDetail = (id) => {
    return instance.get('/cases/'+id).then(response => response.data);
};


/***********************常见问题管理区*********************************/
// 常见问题列表
export const getCommons = (city) => {
    return instance.get('/commons?city='+city).then(response => response.data);
};


/***********************贷款资讯理区*********************************/
// 贷款资讯列表
export const getInfos = (city) => {
    return instance.get('/infos?city='+city).then(response => response.data);
};

// 文章数据详情
export const getInfoDetail = (id) => {
    return instance.get('/infos/'+id).then(response => response.data);
};


/***********************赢通理区*********************************/
// 赢通TOKEN生成
export const getWin = () => {
    return instance.get('/win').then(response => response.data);
};

// 配置赢通第三方接口请求数据
let getInstance = Axios.create({
    baseURL: "https://rsb-stg.pingan.com.cn",
    withCredentials:false,
    headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
});

// 1.04 提交线索信息
export const getArchive = params => {
    return getInstance.post('/brop/front/openapi/ch-2148/cfss_echannel.api.submitArchives', qs.stringify(params)).then(response => response.data);
};


/***********************用户管理区*********************************/

// 用户登录
export const getLogin = params => {
    return instance.post('/phone',qs.stringify(params)).then(response => response.data);
};

// 用户信息
export const getUserInfo = () => {
    return instance.get('/user').then(response => response.data);
};

// 用户登出
export const getUserLogout = params => {
    return instance.post('/logout',qs.stringify(params)).then(response => response.data);
};

// 报备添加
export const getReport = params => {
    return instance.post('/report',qs.stringify(params)).then(response => response.data);
};

// 报备查询
export const getReportQuery = () => {
    return instance.get('/reportList').then(response => response.data);
};

// 报备显示
export const getReportShow = (id) => {
    return instance.get('/reportShow/'+id).then(response => response.data);
};

// 我的报备查询
export const getUserReportQuery = (user_id) => {
    return instance.get('/userReport?id='+user_id).then(response => response.data);
};

// 我的报备详情
export const getUserReportShow = (user_id) => {
    return instance.get('/userReportShow/'+user_id).then(response => response.data);
};


// 族谱列表
export const getClan = () => {
    return instance.get('/clan').then(response => response.data);
};

// 族谱详情
export const getClanShow = (id) => {
    return instance.get('/clan/show?id='+id).then(response => response.data);
};

// 族谱列表
export const getManualOne = () => {
    return instance.get('/manual-one').then(response => response.data);
};

// 族谱详情一
export const getManualOneShow = (id) => {
    return instance.get('/manual-one/show?id='+id).then(response => response.data);
};

// 族谱列表
export const getManualTwo = (id) => {
    return instance.get('/manual-two?id='+id).then(response => response.data);
};

// 族谱详情二
export const getManualTwoShow = (id) => {
    return instance.get('/manual-two/show?id='+id).then(response => response.data);
};

// 捐赠
export const getDonation = () => {
    return instance.get('/donation').then(response => response.data);
};

// 捐赠详情
export const getDonationShow = (id) => {
    return instance.get('/donation/show?id='+id).then(response => response.data);
};
